import { Box, Typography, styled } from '@mui/material';
import { useLocales } from 'src/locales';

const StyledContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.divider,
  padding: theme.spacing(0.25, 1),
  lineHeight: 1,
  whiteSpace: 'nowrap',
}));

export const SharedWithYou = () => {
  const { translate } = useLocales();
  return (
    <StyledContainer>
      <Typography variant="caption">
        {translate('shared.buttons.shared_with_you')}
      </Typography>
    </StyledContainer>
  );
};
